const absoluteUrlRegex = new RegExp('^[a-z+]+://', 'i');

export function absoluteUrl(str: string) {
  return absoluteUrlRegex.test(str);
}
